// The shell's one-shot probe of the tenant feature `statics-feedback` (#165 AK12,
// src/core/staticsFeedbackFeature.ts): the cheapest statics feedback root, a type lookup that
// finds nothing.
import { graphql } from 'src/graphql'

export const StaticsFeedbackFeatureProbeDocument = graphql(/* GraphQL */ `
  query StaticsFeedbackFeatureProbe {
    staticsFeedbackType(id: "00000000-0000-0000-0000-000000000000") {
      id
    }
  }
`)
